import { __makeTemplateObject } from "tslib";
import styled from "styled-components";
export var FieldInfoContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  gap: ", ";\n  color: ", ";\n  font-size: ", ";\n  font-style: normal;\n  font-weight: 400;\n  line-height: ", ";\n  height: ", ";\n  letter-spacing: 0.4px;\n  position: absolute;\n  bottom: calc(\n    -", " - 2px\n  );\n\n  svg {\n    fill: ", ";\n    font-size: 16px;\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  gap: ", ";\n  color: ", ";\n  font-size: ", ";\n  font-style: normal;\n  font-weight: 400;\n  line-height: ", ";\n  height: ", ";\n  letter-spacing: 0.4px;\n  position: absolute;\n  bottom: calc(\n    -", " - 2px\n  );\n\n  svg {\n    fill: ", ";\n    font-size: 16px;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.spacing.xxs;
}, function (_a) {
    var theme = _a.theme, $isError = _a.$isError, $isDisabled = _a.$isDisabled;
    return $isError
        ? theme.colors.red.default
        : $isDisabled
            ? theme.colors.neutral.light
            : theme.colors.neutral.dark;
}, function (_a) {
    var theme = _a.theme;
    return theme.components.fieldInfo.fontSize[theme.device];
}, function (_a) {
    var theme = _a.theme;
    return theme.components.fieldInfo.fontSize[theme.device];
}, function (_a) {
    var theme = _a.theme;
    return theme.components.fieldInfo.fontSize[theme.device];
}, function (_a) {
    var theme = _a.theme;
    return theme.components.fieldInfo.fontSize[theme.device];
}, function (_a) {
    var theme = _a.theme, $isError = _a.$isError, $isDisabled = _a.$isDisabled;
    return $isError
        ? theme.colors.red.default
        : $isDisabled
            ? theme.colors.neutral.light
            : theme.colors.neutral.dark;
});
var templateObject_1;
//# sourceMappingURL=styles.js.map